'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Search = function Search(props) {
  return React__default["default"].createElement("svg", _objectSpread({
    width: "234",
    height: "234",
    viewBox: "0 0 234 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default["default"].createElement("rect", {
    x: "115.965",
    y: "123.321",
    width: "10",
    height: "58",
    transform: "rotate(-45 115.965 123.321)",
    fill: "#93C0E4",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("circle", {
    cx: "84.8528",
    cy: "85.1371",
    r: "52",
    transform: "rotate(-45 84.8528 85.1371)",
    stroke: "#3387CD",
    strokeWidth: "16"
  }), React__default["default"].createElement("path", {
    d: "M44.3657 126.503C21.5201 103.657 21.5201 66.617 44.3657 43.7713",
    stroke: "#C2DBF0",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("circle", {
    cx: "84.853",
    cy: "85.1371",
    r: "47",
    transform: "rotate(-45 84.853 85.1371)",
    fill: "#2196F3",
    fillOpacity: "0.1",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M55.1541 114.836C38.752 98.4335 38.752 71.8406 55.1541 55.4386",
    stroke: "white",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M190.919 191.203C187.404 194.718 181.706 194.718 178.191 191.203L135.058 148.07C134.277 147.288 134.277 146.022 135.058 145.241L144.957 135.342C145.738 134.561 147.005 134.561 147.786 135.342L190.919 178.475C194.434 181.99 194.434 187.688 190.919 191.203Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M190.919 191.203C187.404 194.718 181.706 194.718 178.191 191.203L135.058 148.07C134.277 147.288 134.277 146.022 135.058 145.241L144.957 135.342C145.738 134.561 147.005 134.561 147.786 135.342L190.919 178.475C194.434 181.99 194.434 187.688 190.919 191.203Z",
    stroke: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "136.825",
    y: "141.352",
    width: "12",
    height: "3",
    rx: "1.5",
    transform: "rotate(-135 136.825 141.352)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "121.778",
    y: "98.7281",
    width: "24",
    height: "1.5",
    rx: "0.75",
    transform: "rotate(-90 121.778 98.7281)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "115.217",
    y: "111.258",
    width: "48",
    height: "1.5",
    rx: "0.75",
    transform: "rotate(-90 115.217 111.258)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "187.207",
    y: "182.188",
    width: "30",
    height: "3",
    rx: "1.5",
    transform: "rotate(-135 187.207 182.188)",
    fill: "#C2DBF0"
  }));
};

module.exports = Search;
